import { Box, Button, Card, Snackbar, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import useThemeRender from "../../theme/useThemeRender";
import "./FritoForumDetailPage.css";
import ViewSummary from "../ViewSummary/ViewSummary";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../constant/apiUrl";
import { getAPI, postAPI } from "../../API/ApiService";
import ForumSubDetailPage from "./ForumSubDetailPage";
import { useSelector, useDispatch } from "react-redux";
import InternalCarousal from "../InternalPages/Carousal-ExpandedView/InternalCarousal";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOffAltOutlinedIcon from "@mui/icons-material/ThumbDownOffAltOutlined";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import { showErrorToast } from "../../utils/Toast/toast";
import {
  clearFritoImages,
  setFritoImage,
} from "../../slices/fritoForumPageSlice";
import fetchAndCacheImage from "../../utils/fetchandCatchImages";
import Loading from "../../utils/Loader";
import { handleShare } from "../../utils/function";
import CommonShareButton from "../LinkScreen/CommonShareButton";
function FritoForumDetailPage() {
  const location = useLocation([]);
  const { id } = useParams();
  const forumCardData = location.state;
  const [data, setData] = useState();
  const documentData = data?.documents || [];
  const videoData = data?.videos || [];
  const linksData = data?.links || [];
  const [loading, setLoading] = useState(true);
  const [isLiked, setIsLiked] = useState(false);
  const [isDisliked, setIsDisliked] = useState(false);
  const [thumbnailFileId, setThumbnailFileId] = useState(null);
  const navigate = useNavigate();
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const { vertical, horizontal, open } = state;
  const { favourite } = useSelector((store) => store.internalPage);
  const [fetch, setFetch] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const handleMoveBack = () => {
    navigate("/frito-forum-main-page");
  };
  const backgroundColorLayer3 = useThemeRender("backgroundColorLayer3");
  const backgroundColorLayer1 = useThemeRender("backgroundColorLayer1");
  const textColorLayer2 = useThemeRender("textColorLayer2");
  const handleLike = async () => {
    if (isLiked) {
      const data = {
        id: forumCardData?.id,
        likes: false,
        dislikes: false,
      };
      try {
        const response = await postAPI(
          `${BASE_URL}/forum/save-forum-metrics`,
          data
        );
        if (response.status === 200) {
          setIsLiked(false); // Remove dislike
          setFetch(!fetch);
        }
      } catch {}
    } else {
      const newData = {
        id: forumCardData?.id,
        likes: true,
        dislikes: false,
      };
      try {
        const response = await postAPI(
          `${BASE_URL}/forum/save-forum-metrics`,
          newData
        );
        if (response?.status === 200) {
          console.log(response, "------response--------");
          setIsLiked(true); // Set like
          setIsDisliked(false); // Remove dislike (toggle logic)
          setFetch(!fetch);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleDislike = async () => {
    if (isDisliked) {
      const data = {
        id: forumCardData?.id,
        likes: false,
        dislikes: false,
      };
      try {
        const response = await postAPI(
          `${BASE_URL}/forum/save-forum-metrics`,
          data
        );
        if (response.status === 200) {
          console.log(response, "--dislikedResponse----------");
          setIsDisliked(false); // Remove dislike

          setFetch(!fetch);
        }
      } catch {}
    } else {
      const newData = {
        id: forumCardData?.id,
        likes: false,
        dislikes: true,
      };
      try {
        const response = await postAPI(
          `${BASE_URL}/forum/save-forum-metrics`,
          newData
        );
        if (response.status === 200) {
          setIsDisliked(true); // Set dislike
          setIsLiked(false); // Remove like (toggle logic)
          setFetch(!fetch);
        }
        if (response?.status === 400) {
          showErrorToast(response?.message);
        }
      } catch (error) {
        console.log(error, "-----err-------");
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAPI(
          `${BASE_URL}/forum/find-by-forum-id/${id}`
        );
        if (response?.status === 200) {
          console.log(response, "response forum----");
          dispatch(clearFritoImages());

          const thumbId = response.data?.response?.thumbnailFileId;
          if (thumbId) {
            setThumbnailFileId(thumbId); // Set separately for second useEffect
          }

          setData(response?.data?.response);
          setIsLiked(response?.data?.response?.liked);
          setIsDisliked(response?.data?.response?.disliked);
        }
      } catch (err) {
        showErrorToast(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, favourite, dispatch, forumCardData, fetch]);

  useEffect(() => {
    if (thumbnailFileId) {
      const downloadImage = async () => {
        try {
          await fetchAndCacheImage(thumbnailFileId, setFritoImage, dispatch);
        } catch (err) {
          console.error("Image download failed", err);
        }
      };
      downloadImage();
    }
  }, [thumbnailFileId, dispatch]);

  if (loading) return <Loading />;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
        background: backgroundColorLayer1,
        padding: {
          xs: "0px",
          sm: " 0px 30px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "40px",
          padding: "var(--Spacing-spacing-03, 8px) 0px",
          justifyContent: "center",
          alignItems: "center",
          gap: "var(--Spacing-spacing-03, 8px)",
          margin: {
            xs: "20px 10px 0px",
            sm: "20px 0px 0px",
            md: "16px 0px",
          },
          cursor: "pointer",
        }}
        onClick={handleMoveBack}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
            fill="#005CBC"
          />
        </svg>
        <Typography
          sx={{
            color: "var(--Tokens-Button-Borderless, #005CBC)",
            fontFamily: "var(--Typography-Font-Family-Body, Inter)",
            fontSize: "var(--Font-Size-Body, 16px)",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "var(--Line-Height-Body, 22px)",
          }}
        >
          Back to Frito forum
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "16px",
          width: "100%",
        }}
      >
        <Card
          className="SummaryCard"
          sx={{
            background: backgroundColorLayer3,
            width: "100%",
          }}
        >
          <Typography
            className="SummaryTitle"
            sx={{
              color: textColorLayer2,
              fontSize: "25px !important",
            }}
          >
            {data?.title}
          </Typography>
          <Box
            className="SummaryContentBox"
            sx={{
              background: backgroundColorLayer1,
            }}
          >
            <Typography
              className="ForumSummaryContents"
              sx={{
                color: textColorLayer2,
                width: {
                  xs: "100%",
                  md: "80%",
                },
                padding: "12px",
              }}
            >
              {data?.description}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              alignSelf: "stretch",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "var(--Spacing-spacing-16, 16px)",
                flexWrap: "wrap",
              }}
            >
              <CommonShareButton
                onClick={() => handleShare(location)}
                vertical={vertical}
                horizontal={horizontal}
                open={open}
                onClose={handleClose}
              />
              <Box
                sx={{
                  display: "flex",
                  height: "var(--Spacing-spacing-32, 32px)",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  className="LogoButton"
                  onClick={handleLike}
                  data-testid="like-button"
                >
                  <Typography className="LogoContent">Like</Typography>
                  {isLiked ? (
                    <ThumbUpIcon
                      style={{
                        color: "#005CBC",
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  ) : (
                    <ThumbUpOutlinedIcon
                      style={{
                        color: "#005CBC",
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  )}
                </Button>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  height: "var(--Spacing-spacing-32, 32px)",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button className="LogoButton" onClick={handleDislike}>
                  <Typography className="LogoContent">Dislike</Typography>
                  {isDisliked ? (
                    <ThumbDownAltIcon
                      style={{
                        color: "#005CBC",
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  ) : (
                    <ThumbDownOffAltOutlinedIcon
                      style={{
                        color: "#005CBC",
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
          <Typography
            className="SummaryTitle"
            sx={{
              color: textColorLayer2,
              fontSize: "25px !important",
            }}
          >
            Details
          </Typography>
          <ForumSubDetailPage data={data} />
          <Typography
            className="SummaryTitle"
            sx={{
              color: textColorLayer2,
              fontSize: "25px !important",
            }}
          >
            Disclaimer
          </Typography>
          <Box
            className="SummaryContentBox"
            sx={{
              background: backgroundColorLayer1,
              padding: "12px",
            }}
          >
            <Typography
              className="ForumSummaryContents"
              sx={{
                color: textColorLayer2,
                width: {
                  xs: "100%",
                  md: "80%",
                },
              }}
            >
              {data?.disclaimerText}
            </Typography>
          </Box>
        </Card>
      </Box>
      <Box
        sx={{
          color: textColorLayer2,
          fontFeatureSettings: "'liga' off, 'clig' off",
          fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
          fontSize: "var(--Font-Size-H5, 24px)",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "var(--Line-Height-H5, 32px)",
          marginLeft: "15px",
          mb: "10px",
        }}
      >
        Associated Content
      </Box>
      {/* {documentData?.length > 0 && ( */}
      <Box
        sx={{
          backgroundColor: backgroundColorLayer3,
        }}
        className="curosalBackground"
      >
        <InternalCarousal
          data={documentData}
          content={"Documents"}
          flexDirection={"column"}
          heading={"Documents"}
          isHeadingBig={false}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: backgroundColorLayer3,
        }}
        className="curosalBackground"
      >
        <InternalCarousal
          data={videoData}
          content={"Videos"}
          flexDirection={"column"}
          heading={"Videos"}
          isHeadingBig={false}
        />
      </Box>

      <Box
        sx={{
          backgroundColor: backgroundColorLayer3,
          marginBottom: "16px",
        }}
        className="curosalBackground"
      >
        <InternalCarousal
          data={linksData}
          content={"Links"}
          flexDirection={"column"}
          heading={"Links"}
          isHeadingBig={false}
        />
      </Box>

      <ViewSummary />
    </Box>
  );
}

export default FritoForumDetailPage;
